import { fetchWithTimeout } from '@core/utils/publicToken';
import { getInterviewPublicEdgeUrl, interviewEdgeConfigErrorMessage } from '@core/utils/interviewEnv';
import { parseInterviewEdgeJson } from '@core/utils/interviewEdgeResponse';

export function publicInterviewHeaders(): Record<string, string> {
  return {
    apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    Authorization: `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
  };
}

/** POST experience rating via public Edge (magic-link token). */
export async function postInterviewExperienceFeedback(token: string, rating: number): Promise<void> {
  const url = getInterviewPublicEdgeUrl();
  if (!url) {
    throw new Error(interviewEdgeConfigErrorMessage() ?? 'Interview API is not configured.');
  }
  const r = await fetchWithTimeout(url, {
    method: 'POST',
    headers: { ...publicInterviewHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, action: 'experience_feedback', experience_rating: rating }),
    timeoutMs: 60_000,
  });
  const text = await r.text();
  const parsed = parseInterviewEdgeJson(text);
  const data = (parsed.ok ? parsed.data : { error: 'Request failed' }) as { error?: string; ok?: boolean };
  const err = data.error;
  if (!r.ok || err) {
    throw new Error(err ?? 'Could not save your rating.');
  }
}
